import { __awaiter, __generator } from "tslib";
import { _Web } from "../webs/types.js";
import { CreateClientsidePage, ClientsidePageFromFile, ClientsideWebpart, } from "./types.js";
import { SharePointQueryableInstance, SharePointQueryableCollection } from "../sharepointqueryable.js";
import { extractWebUrl } from "../utils/extractweburl.js";
import { spPost } from "../operations.js";
import { body } from "@pnp/odata";
import { metadata } from "../utils/metadata.js";
import { assign } from "@pnp/common";
_Web.prototype.getClientsideWebParts = function () {
    return this.clone(SharePointQueryableCollection, "GetClientSideWebParts")();
};
_Web.prototype.addClientsidePage =
    function (pageName, title, layout, promotedState) {
        if (title === void 0) { title = pageName.replace(/\.[^/.]+$/, ""); }
        return CreateClientsidePage(this, pageName, title, layout, promotedState);
    };
_Web.prototype.loadClientsidePage = function (path) {
    return ClientsidePageFromFile(this.getFileByServerRelativePath(path));
};
_Web.prototype.addRepostPage = function (details) {
    return __awaiter(this, void 0, void 0, function () {
        var query, r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = SharePointQueryableInstance(extractWebUrl(this.toUrl()), "_api/sitepages/pages/reposts").configureFrom(this);
                    return [4 /*yield*/, spPost(query, body(assign(metadata("SP.Publishing.RepostPage"), details)))];
                case 1:
                    r = _a.sent();
                    return [2 /*return*/, r.AbsoluteUrl];
            }
        });
    });
};
// eslint-disable-next-line max-len
_Web.prototype.addFullPageApp = function (pageName, title, componentId, promotedState) {
    if (title === void 0) { title = pageName.replace(/\.[^/.]+$/, ""); }
    return __awaiter(this, void 0, void 0, function () {
        var parts, test, partDef, part, page;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getClientsideWebParts()];
                case 1:
                    parts = _a.sent();
                    test = new RegExp("{?" + componentId + "}?", "i");
                    partDef = parts.find(function (p) { return test.test(p.Id); });
                    part = ClientsideWebpart.fromComponentDef(partDef);
                    return [4 /*yield*/, this.addClientsidePage(pageName, title, "SingleWebPartAppPage", promotedState)];
                case 2:
                    page = _a.sent();
                    page.addSection().addColumn(12).addControl(part);
                    return [2 /*return*/, page];
            }
        });
    });
};
//# sourceMappingURL=web.js.map